<ion-select
  [value]="value"
  (ionChange)="onInputChange($event)" 
  (ionBlur)="onInputBlur()"
  [placeholder]="actualPlaceholder"
  [interfaceOptions]="interfaceOptions"
  labelPlacement="stacked"
  [label]="labelText"
  [attr.required]="required ? true : null"
  [class.invalid]="isInvalid"
  [attr.autocomplete]="autocomplete ? autocomplete : null"
  color="dark"
  fill="outline"
 
  cancelText="{{cancelText}}" okText="{{okText}}"
>
  <ion-icon *ngIf="iconStartSrc" slot="start" aria-hidden="true" [src]="iconStartSrc"></ion-icon>
  <ion-icon *ngIf="iconEndSrc" slot="end" aria-hidden="true" [src]="iconEndSrc"></ion-icon>
  <ng-content></ng-content>
</ion-select>
